import { render, staticRenderFns } from "./addFormDialog.vue?vue&type=template&id=939446e6&scoped=true&lang=pug"
import script from "./addFormDialog.vue?vue&type=script&lang=js"
export * from "./addFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939446e6",
  null
  
)

export default component.exports